import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError, ITotalItems } from '@unfoldrtech/portal-mic'
import {
  EReportColumnHeader,
  IReportingTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/openapi/core/sdk/api'
import { coreAPI } from '../services/coreAPI'
import {
  generateCorrelationId,
  getTZOffset,
  getTimezone,
} from '../utils/helpers'
import {
  TCampaignsReportTableFilters,
  TPPAdvertiserId,
  TPPRetailerId,
} from '../models/types'
import { IReportPageTypes } from '../models/interfaces'

export default function useGetV2AdvertiserReportingCampaignTable({
  advertiserId,
  retailerId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzOffset,
  tzZone,
  aggregationType,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TCampaignsReportTableFilters &
  TPPRetailerId &
  TPPAdvertiserId &
  IReportPageTypes): UseQueryResult<
  AxiosResponse<ITotalItems & IReportingTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingCampaignTable_${advertiserId}_${retailerId}_${
    channelType || ''
  }`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    ({ queryKey }) => {
      const filters = queryKey[1] || {}
      const { start, end } = filters as { start: string; end: string }

      return coreAPI
        .v2AdvertiserReporting()
        .getAdvertiserCampaignsReportTable(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          channelType,
          sortBy as EReportColumnHeader,
          timeWindow,
          start,
          end,
          sortOrder,
          tzOffset || getTZOffset(endDate),
          tzZone || getTimezone(),
          aggregationType
        )
    },
    { suspense, enabled }
  )
}
